import React, { Fragment, useState, useEffect } from 'react';
import Breadcrumb from '../common/breadcrumb';
import Tablereact from '../common/tabulator/tablereact';
import AgregarUsuario from './agregarUsuario';
import ActualizarUsuario from './actualizarUsuario';
import Loader from '../common/loaderapp';
import Button from 'react-bootstrap-button-loader';
import { useUserPermisos } from '../hooks/useUserPermisos';

const Usuarios = () => {

    const [pag_agregar, setPag_agregar] = useState(false);
    const [pag_actualizar, setPag_actualizar] = useState(0);
    const [load, setLoad] = useState(false);
    const [datos, setDatos] = useState([]);
    const [reloadUsuarios, setReloadUsuarios] = useState(0);
    const { usuario } = useUserPermisos();
    const puedeVerContrasenas = usuario?.tipo_usuario === 3;

    const cargarUsuarios = () => {
        setLoad(false);
        fetch('/p_usuarios')
            .then(res => res.json())
            .then(res => {
                setDatos(Array.isArray(res) ? res : []);
                setLoad(true);
            })
            .catch(error => {
                console.error('Error al cargar usuarios:', error);
                setDatos([]);
                setLoad(true);
            });
    };

    useEffect(() => {
        cargarUsuarios();
    }, [reloadUsuarios]);

    const cabecera = [
        {
            Header: <b>Nombre</b>,
            accessor: 'nombres',
            show: true,
            style: { textAlign: 'center' },
            headerStyle: { textAlign: 'center' }
        },
        {
            Header: <b>Correo</b>,
            accessor: 'correo',
            show: true,
            style: { textAlign: 'center' },
            headerStyle: { textAlign: 'center' }
        },
        {
            Header: <b>Tipo</b>,
            accessor: 'tipo',
            show: true,
            style: { textAlign: 'center' },
            headerStyle: { textAlign: 'center' }
        },
        {
            Header: <b>Contraseña</b>,
            accessor: 'contrasena',
            show: puedeVerContrasenas,
            style: { textAlign: 'center' },
            headerStyle: { textAlign: 'center' }
        },
        {
            Header: <b>Estado</b>,
            accessor: 'estado',
            show: true,
            style: { textAlign: 'center' },
            headerStyle: { textAlign: 'center' }
        }
    ];

    const agregar = () => setPag_agregar(true);
    const detalle_dato = (dato) => {
        setPag_actualizar(dato.id);
    };

    const onUsuarioGuardado = () => {
        setPag_agregar(false);
        setReloadUsuarios(prev => prev + 1);
    };

    const onUsuarioActualizado = () => {
        setPag_actualizar(0);
        setReloadUsuarios(prev => prev + 1);
    };

    return (
        <Fragment>
            <Breadcrumb parent="Inicio" title="Usuarios" />

            {load ? (

                (!pag_agregar && !pag_actualizar) ? (

                    <div className="container-fluid">
                        <div className="col-sm-12">
                            <div className="card">

                                <div className="d-flex flex-row-reverse" style={{ paddingRight: 38, paddingTop: 10 }}>
                                    <Button className="btn btn-primary" onClick={agregar}>
                                        Agregar usuario
                                    </Button>
                                </div>

                                <div className="card-body datatable-react">
                                    <Tablereact
                                        myData={datos}
                                        cabecera={cabecera}
                                        pageSize={20}
                                        paginacion={true}
                                        buscador="Buscar usuario"
                                        detalle={detalle_dato}
                                    />
                                </div>

                            </div>
                        </div>
                    </div>

                ) : (!pag_actualizar ?

                    <AgregarUsuario
                        setPag_agregar={setPag_agregar}
                        onUsuarioGuardado={onUsuarioGuardado}
                    /> :
                    <ActualizarUsuario
                        pag_actualizar={pag_actualizar}
                        setPag_actualizar={setPag_actualizar}
                        onUsuarioActualizado={onUsuarioActualizado}
                    />

                )

            ) : (
                <Loader />
            )}

        </Fragment>
    );
};

export default Usuarios;
